import { Injectable } from '@angular/core';
import { HttpModule } from '@angular/http';
import {  Http, Headers, RequestOptions } from '@angular/http';

@Injectable()
export class FileService {

postFile(fileToUpload: File, font_data,type_conv) {
	var headers = new Headers();
        headers.append("Accept", 'application/json');
        //headers.append('Content-Type', 'multipart/form-data' );
        let options = new RequestOptions({ headers: headers });

    const endpoint = 'http://14.139.174.73:81/' + type_conv;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('font', font_data)
    return this.http.post(endpoint, formData, options) .map(res =>  res.json());
}

  constructor(public http: Http) { }

}



// WEBPACK FOOTER //
// ./src/app/file.service.ts